import { Button, Card, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FormProvider } from "react-hook-form";
import { useSelector } from "react-redux";

import {
  AdminMenuLayout,
  ModalListCustomerGroups,
} from "../../../shared/components";
import { BRAND } from "../../../shared/theme/brand";
import { selectModalListCustomerGroups } from "../../../redux";
import { TableListCustomerGroups } from "./TableListCustomerGroups";
import { useListCustomerGroups } from "../hooks";

export const ListCustomerGroups = () => {
  const modalListCustomerGroups = useSelector(selectModalListCustomerGroups);
  const {
    isUpdateListCustomerGroups,
    formMethodsCreate,
    changeModalListCustomerGroupsState,
  } = useListCustomerGroups();

  return (
    <AdminMenuLayout
      pageDescription="Grupos de clientes"
      title="Grupos de clientes"
    >
      <Card
        bodyStyle={{ padding: "24px", display: "block" }}
        style={{
          borderRadius: 12,
          border: "none",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            marginBottom: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 16,
          }}
        >
          <h2
            style={{
              fontSize: 20,
              fontWeight: 600,
              margin: 0,
              color: "#262626",
            }}
          >
            Grupos de clientes
          </h2>

          <Space size={12}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalListCustomerGroupsState}
              style={{
                borderRadius: "30px",
                fontWeight: 600,
                padding: "0 24px",
                height: 44,
                boxShadow: BRAND.primaryShadow,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Nuevo grupo
            </Button>
          </Space>
        </div>

        <TableListCustomerGroups />

        {modalListCustomerGroups && !isUpdateListCustomerGroups && (
          <FormProvider {...formMethodsCreate}>
            <ModalListCustomerGroups />
          </FormProvider>
        )}
      </Card>
    </AdminMenuLayout>
  );
};
